module.exports = __webpack_public_path__ + "img/salon-design.c99047ff.svg";